import React from 'react';
import './CategoryTabs.css';

/**
 * CategoryTabs - A reusable component for displaying category tabs with horizontal scrolling
 * 
 * @param {Object} props
 * @param {Array} props.categories - Array of category objects with id and label properties
 * @param {string} props.activeCategory - The currently active category id
 * @param {function} props.onCategoryChange - Callback function when a category is selected
 * @param {string} [props.className] - Optional additional CSS class name
 * @returns {JSX.Element}
 */
function CategoryTabs({ categories, activeCategory, onCategoryChange, className = '' }) {
  if (!categories || categories.length == 0) {
    return null;
  }

  return (
    <div className={`category-tabs ${className}`}>
      {categories.map(category => (
        <button
          key={category.id}
          className={`category-tab ${activeCategory == category.id ? 'active' : ''}`}
          onClick={() => onCategoryChange(category.id)}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
}

export default CategoryTabs;